import React from 'react'
import Paginate from 'components/paginate'
import {Link} from 'react-router-dom'
import {SimpleBanner} from './banner'


export class Content extends React.Component {
	render() {
		const {content} = this.props;

		return (
			<a href={content.href} target="_blank" className={this.props.className || "infoteca"}>
				<div>
					<img src={content.image} alt="" />
				</div>
				<div className="name">{content.name}</div>
			</a>
		);
	}
}

export default class DynamicContent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.componentWillReceiveProps(props);
	}

	componentWillReceiveProps(props) {
		this.state.category = props.match && props.match.params.catid
			? props.match.params.catid
			: (props.category || null);
		this.state.type = this.state.category ? null : (props.type || 'pubs');
		if (this.state.category) {
			http.get('/home/getDynamicContent.json', {catalias: this.state.category}, response => {
				this.setState({title: response.category.category})
			})
		}
		else {
			this.state.title = __('socials_' + this.state.type);
		}
	}

	render() {
		const {type, category} = this.state;
		let body = null;

		if (category) {
			body =
				<Paginate
					//items={this.state.members}
					url={'/home/getDynamicContent.json?category=' + category}
					classNameEl="col-sm col-md-4 mb-4"
					itemsPerPage={12}
					renderItem={ content => <Content content={content} history={this.props.history} /> }
					paginationContainer={page_nav =>
						<div key="pc" className="col-sm pagination-container">
							{page_nav}
						</div>
					}
				/>
			}
		else {
			body =
				<Paginate
					//items={this.state.members}
					url={'/home/getDynamicContent.json?type=' + type}
					classNameEl="col-sm col-md-4 mb-4"
					itemsPerPage={12}
					renderItem={ content =>
						React.createElement(
							content.href ? "a" : Link, {
								to: content.href ? null : '/home/infoteca/' + content.alias,
								href: content.href || null,
								target: content.href ? "_blank" : null,
								className: "infoteca"
							}, [
								<div key="a">
									<img src={content.image} alt="" />
								</div>,
								<div key="b" className="name">{content.category}</div>
							]
						)
					}
					paginationContainer={page_nav =>
						<div key="pc" className="col-sm pagination-container">
							{page_nav}
						</div>
					}
				/>
		}
		return (
			<div>
				<SimpleBanner title={this.state.title} />
				<div className="container-fluid">
					<div className="row justify-content-center mt-4">
						{body}
					</div>
				</div>
			</div>
		)
	}
}